import React, { useState } from "react";
import CommonPage from "@icarius-common/commonPage";
import Schedule from "./schedule";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { calendarActionsTypeColors } from "@icarius-utils/colors";
import useActionsSchedule from "./useActionsSchedule";
import useGenericSchedule from "./useGenericSchedule";
import { getLocalizedString } from "@icarius-localization/strings";

const Calendar = (props) => {
  const {
    data,
    colaborators,
    groups,
    handleClose,
    isLoading,
  } = props;
  
  const [view, setView] = useState('week');
  
  const {
    staff,
    shifts,
    handleSubmit,
  } = useActionsSchedule(data, colaborators, groups);
  
  const {
    scheduleFunctions,
    scheduleData,
  } = useGenericSchedule(handleSubmit);
  
  const typesStrings = {
    done: getLocalizedString("completedFemale"),
    pending: getLocalizedString("pending"),
  }

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      type={'goBack'}
      onClick={handleClose}
    />
  )

  const changeViewItem = () => (
    <FormControl style={{ width: '200px', marginLeft: 10, marginRight: 10 }}>
      <InputLabel id={`label-view`}>{getLocalizedString("view2")}</InputLabel>
      <Select
        value={view}
        onChange={(e) => setView(e.target.value)}
        labelId={`label-view`}
        id={`select-view`}
        margin={"none"}
      >
        {
          [
            {
              key: 'week',
              value: getLocalizedString("week"),
            },
            {
              key: 'month',
              value: getLocalizedString("month"),
            },
            {
              key: 'year',
              value: getLocalizedString("year"),
            },
          ].map((item) => (
            <MenuItem
              className={"whiteText"}
              key={item.key}
              value={item.key}
            >
              {item.value}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )

  const typesSelectItem = () => (
    <FormControl style={{ width: '200px', marginLeft: 10, marginRight: 10 }}>
      <InputLabel id={`label`}>{getLocalizedString("type")}</InputLabel>
      <Select
        value={''}
        labelId={`label`}
        id={`select`}
        margin={"none"}
      >
        {
          ['pending', 'done'].map((item) => (
            <MenuItem
              className={"whiteText"}
              key={item}
              value={item}
            >
              <div style={{ marginRight: 10, height: 10, width: 10, borderRadius: '50%', background: calendarActionsTypeColors[item] }} />
              {typesStrings[item]}
            </MenuItem>
          ))
        }
      </Select>
    </FormControl>
  )

  return (
    <CommonPage
      title={getLocalizedString("myPlannedActions")}
      isLoading={isLoading}
      menuItems={[goBackButton, changeViewItem, typesSelectItem]}
      isNotGridPage
    >
      <Schedule
        staff={staff}
        shifts={shifts}
        scheduleFunctions={scheduleFunctions}
        scheduleData={scheduleData}
        view={view}
      />
    </CommonPage>
  )
}

export default Calendar;